import React from 'react'
import { View, Text, Image, ScrollView, Dimensions, Platform } from 'react-native'
import { styles } from './styles'
import Colors from '../../../constants/Colors';
import CS from '../../../constants/Styles';
import Button from '../../../components/Button';
import PlayVideoButton from '../../../components/PlayVideoButton';
import { useLinkTo } from '@react-navigation/native';
import { AntDesign, Entypo } from '@expo/vector-icons';

export const TutorialCarouselItem = ({ item, ...props }) => {

  // const [imgWebStyle, setImgWebStyle] = React.useState({});

  // const windowWidth = Dimensions.get('window').width;
  const linkTo = useLinkTo();
  let scrollRef = React.useRef(null);
  // const { title } = props;

  // React.useEffect(() => {
  //   setImgWebStyle(imgStyle(windowWidth));
  //   if (Platform.OS === 'web') {
  //     Dimensions.addEventListener('change', onChangeDimensions);
  //     return () => {
  //       Dimensions.removeEventListener('change', onChangeDimensions);
  //     }
  //   }
  // }, []);

  const goTo = () => {
    console.log('Go to ', item.goTo);
    linkTo(item.goTo);
  }

  // const onChangeDimensions = ({ window, screen }) => {
  //   console.log('onChangeDimensions');
  //   setImgWebStyle(imgStyle(window.width));
  // };

  // const imgStyle = (windowWidth) => {
  //   const ratio = item.image.height / item.image.width;
  //   if (Platform.OS === 'web') {
  //     let width = windowWidth >= 768 ? 768 : windowWidth;
  //     if(width > 400){ width = 400; }
  //     return {
  //       width: width,
  //       height: width * ratio,
  //     }
  //   }
  //   return { aspectRatio: item.image.width / item.image.height }
  // }

  const innerContent = () => {
    return (
      <>
        {/* <Image style={[CS.responsiveImage, styles.img, imgWebStyle]} source={item.image.source} /> */}
        <Text style={[CS.smallTitle, CS.lightText, CS.centerText, styles.title]}>{item.title}</Text>
        {item.description.map((t, i) => {
          // return <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]} key={i}>{t}</Text>
          return <View key={i}>{t}</View>
        })}
        {item.sections.map((section, i) => {
          return (
            <View style={styles.section} key={i}>
              <Text style={[CS.smallText, CS.lightText, CS.boldText, styles.sectionTitle]}>{section.title}</Text>
              {section.description ?
                <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>{section.description}</Text>
                : null}
              {section.items.map((sectionItem, i) => {
                return (
                  <View key={i}>
                    <View style={styles.sectionItem}>
                      <Text style={[CS.smallText, CS.lightBlueText, styles.sectionNumber]}>{i+1}.</Text>
                      <Text style={[CS.smallText, CS.lightBlueText, { flex: 1 }]}>
                        <Text style={[CS.lightText, CS.boldText]}>{sectionItem.name}</Text>
                        {sectionItem.text ? ` - ${sectionItem.text}` : null}
                      </Text>
                    </View>
                    {
                      sectionItem.note ?
                        <Text style={[CS.smallText, CS.lightBlueText, styles.sectionNote]}><Text style={[CS.lightText, CS.boldText]}>Important Note</Text> - {sectionItem.note}</Text>
                        : null
                    }
                  </View>
                )
              })}
              {/* {section.footer ?
                <Text style={[CS.smallText, CS.lightBlueText, styles.sectionFooter]}>{section.footer}</Text>
              : null} */}
              {/* {section.footer.map((f, i) => {
                return <Text style={[CS.smallText, CS.lightBlueText, styles.sectionFooter]} key={i}>{f}</Text>
              })} */}
              {section.footer.map((f, i) => {
                return <View key={i}>{f}</View>
              })}
            </View>
          )
        })}


        {item.mustHave &&
          <Text style={[CS.smallText, CS.lightBlueText, styles.listTitle]}>You MUST HAVE:</Text>
        }
        {item.mustHave && item.mustHave.items.map((text, i) => {
          return (
            <View style={[CS.rowContainer]} key={i}>
              <AntDesign name='check' size={24} color={Colors.yellow} style={styles.listIcon} />
              <Text style={[CS.smallText, CS.lightBlueText]}>{text}</Text>
            </View>
          )
        })}
        {item.mustHave && item.mustHave.description &&
          <View style={styles.descriptionContainer}>
          {item.mustHave && item.mustHave.description.map((t, i) => {
            return <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]} key={i}>{t}</Text>
          })}
          </View>
        }
        
        {item.need ?
          <Text style={[CS.smallText, CS.lightBlueText, styles.listTitle]}>You will need the following:</Text>
          : null}
        {item.need && item.need.items.map((item, i) => {
          return (
            <View style={CS.rowContainer} key={i}>
              <AntDesign name='check' size={24} color={Colors.yellow} style={styles.listIcon} />
              {item}
            </View>
          )
        })}
        {item.need && item.need.description && 
          <View style={styles.descriptionContainer}>
          {item.need && item.need.description.map((t, i) => {
            // return <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]} key={i}>{t}</Text>
            return <View key={i}>{t}</View>
          })}
          </View>
        }
        
        {item.source ?
          <PlayVideoButton
            text='How to create a project'
            length='2:03'
            source={item.source}
            youtube={item.youtube}
            outerContainerStyle={{ marginVertical: 20 }}
            scrollRef={scrollRef}
          />
          : null}
        {item.button &&
          <Button text={item.button} onPress={() => goTo} style={styles.button} />
        }
      </>
    )
  }

  const outerContent = () => {
    // if (Platform.OS === 'web') {
    //   return (
    //     <View style={styles.container}>
    //       {innerContent()}
    //     </View>
    //   );
    // } else {
      return (
        <ScrollView style={styles.container} ref={scrollRef}>
          {innerContent()}
        </ScrollView>
      );
    // }
  }

  return outerContent();
}

export default TutorialCarouselItem;